export default "__VITE_ASSET__0c86ca27__"